<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableDedicatedHostingResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          title: this.$t("RAM.AWS.DedicatedHosting.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.hostId"),
          key: "hostId"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.availabilityZone"),
          key: "availabilityZone"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.state"),
          key: "state"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.instanceFamily"),
          key: "instanceFamily"
        },
        {
          title: this.$t("RAM.AWS.DedicatedHosting.instanceType"),
          key: "instanceType"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountIdList", function(val) {
      tableDataVue.accountIdList = val;
    });
    eventBus.$on("hostId", function(val) {
      tableDataVue.hostId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      var jjson = {};
      if (null != tableDataVue.companyId) {
        jjson.companyId = tableDataVue.companyId;
      }
      if (null != tableDataVue.hostId && "" != tableDataVue.hostId) {
        jjson.hostId = tableDataVue.hostId;
      }
      if (null != tableDataVue.accountIdList) {
        jjson.accountIdList = tableDataVue.accountIdList;
      }
      jjson.pageNum = this.current;
      jjson.pageSize = this.pageSize;
      this.$api.resourceManagement
        .pagingQueryWSDedicatedHost(jjson)
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/bsh/TableDedicatedHostingResource.vue